/* global axios */
import ApiClient from './ApiClient';

class AttributeAPI extends ApiClient {
  constructor() {
    super('custom_attribute_definitions', { accountScoped: true });
  }

  getAttributesByModel() {
    return axios.get(this.url);
  }
  // get llm contact atttributes
  fetchLLMContactAttributes(){
    return axios.get(`${this.url}/llm_contact_attr`);
  }
}

export default new AttributeAPI();
